<template>
  <div class="header-wrap">

    <!-- 弹出层 -->
    <demonstration v-if="demShow" @onOff="typeShow"></demonstration>

    <!-- 图片预览 -->
    <div v-show="previewImg.needShowImgPreviewCommon">
      <dialog-image-preview-common></dialog-image-preview-common>
    </div>

    <div class="login-pop-ups">

      <!-- 图形验证码 -->
      <div class="graphic-veri-wrap" v-if="isGraphic">
        <div class="graphic-veri">
          <form @keyup.enter="sendImgCodeData">
            <div class="veri-title">图形验证码</div>
            <div class="veri-content">
              <div class="veri-picture" @click="handler_getVeri">
                <img :src="imageCode.src" v-if="imageCode.src !== ''">
              </div>
              <div class="veri-text">
                <input type="text" placeholder="请输入左侧图形验证码" v-model.trim="userVeri">
              </div>
            </div>
            <div class="cancel-confirm">
              <div class="confirm" @click="sendImgCodeData">确定</div>
              <div class="cancel" @click="closeGraphic">取消</div>
            </div>
          </form>
        </div>
      </div>

      <!-- 登录弹窗 -->
      <div class="dialog-login-wrap" v-if="dialogFormVisible">
        <div class="login-wrap">
          <div class="dialog-log-title">
            <div class="title-text">登录</div>
            <div class="dialog-log-close" @click="closeLogin"></div>
          </div>
          <div v-if="!isRegis" class="options">
            <form @keyup.enter="handler_login">
              <div class="phone">
                <input type="text" placeholder="请输入手机号码" v-model.trim="userPhone">
              </div>
              <div class="password">
                <input type="password" placeholder="请输入密码" v-model="userPassword">
              </div>
              <div class="more-option">
                <div class="remember">
                  <label for="remember">
                    <input type="checkbox" class="reme-button" id="remember">
                    <div class="reme-text">记住账号</div>
                  </label>
                </div>
                <div class="registered" @click="handler_registered">还未设置密码？</div>
              </div>
              <div class="prompt">{{ promptText }}</div>
              <div class="login-bun" @click="handler_login">登录</div>
            </form>
          </div>
          <div v-else class="options">
            <form @keyup.enter="codeLogin">
              <div class="phone">
                <input type="text" placeholder="请输入手机号码" v-model.trim="userPhone">
              </div>
              <div class="examine">
                <input type="text" placeholder="请输入验证码" v-model.trim="userPhoneVeri">
                <div class="get-examine" @click="handler_getVeri">{{ veriText }}</div>
              </div>
              <div class="prompt">{{ promptText }}</div>
              <div class="login-bun" @click="codeLogin">登录</div>
            </form>
          </div>
        </div>
      </div>

      <!-- 顶部导航栏 -->
      <header>
        <div class="logo-wrap">
          <div class="logo">
            <img src="../../icons/image/plusLogo.svg" @click="jumpPlusIndex">
          </div>
        </div>
        <div class="nav">
          <div class="nav-item" @click="jumpPlusIndex"><div class="click-icon">首页</div></div>
          <div class="nav-item" @click.stop="showMenu('fuc')" @mouseenter.self="showMenu('fuc')" @mouseleave.self="showMenu('')">
            <div class="click-icon">
              功能
              <img src="../../icons/image/select-blue.svg" v-if="showMenuKey === 'fuc'">
              <img src="../../icons/image/select.svg" v-else>
              <div class="fuc-item" v-if="showMenuKey==='fuc'">
                <div class="fuc-left">
                  <div @click="jumpTask"><img src="../../icons/image/task-icon.svg">任务</div>
                  <div @click="jumpProject"><img src="../../icons/image/project-icon.svg">项目</div>
                  <div @click="jumpCRM"><img src="../../icons/image/crm-icon.svg">CRM</div>
                  <div @click="jumpPSI"><img src="../../icons/image/psi-icon.svg">进销存</div>
                </div>
                <div class="fuc-right">
                  <div @click="jumpAPE"><img src="../../icons/image/ape-icon.svg">绩效</div>
                  <div @click="jumpRecruitment"><img src="../../icons/image/recruitment-icon.svg">招聘</div>
                  <div @click="jumpOA"><img src="../../icons/image/hr-icon.svg">OA</div>
                </div>
              </div>
            </div>
          </div>
          <div class="nav-item" @click.stop="showMenu('sup')" @mouseenter.self="showMenu('sup')" @mouseleave.self="showMenu('')">
            <div class="click-icon">
              技术与支持
              <img src="../../icons/image/select-blue.svg" v-if="showMenuKey === 'sup'">
              <img src="../../icons/image/select.svg" v-else>
              <div class="support-item" v-if="showMenuKey==='sup'">
                <div @click="jumpConsultation"><img src="../../icons/image/implement-icon.svg">咨询服务</div>
                <div @click="jumpImplementation"><img src="../../icons/image/consult-icon.svg">实施服务</div>
              </div>
            </div>
          </div>
          <div class="nav-item" @click.stop="showMenu('plus')" @mouseenter.self="showMenu('plus')" @mouseleave.self="showMenu('')">
            <div class="click-icon">
              关于加号
              <img src="../../icons/image/select-blue.svg" v-if="showMenuKey === 'plus'">
              <img src="../../icons/image/select.svg" v-else>
              <div class="plus-item" v-if="showMenuKey==='plus'">
                <div @click="jumpPlusTeam"><img src="../../icons/image/plusTeam-icon.svg">加号团队</div>
                <div @click="jumpPlusCulture"><img src="../../icons/image/plusCulture-icon.svg">加号文化</div>
              </div>
            </div>
          </div>
          <div class="nav-item" @click="jumpJoinPlus"><div class="click-icon">加入加号</div></div>
          <div class="nav-item" @click="$router.push( '/')"><div class="click-icon">帮助中心</div></div>
          <div class="nav-item" @click="goSchedule"><div class="click-icon">预约演示</div></div>

          <div class="fix-bar">
            <div class="login-exit" v-if="isLogin">
              <div class="user" @click="jumpTaskIndex">
                <div class="user-icon"><img :src="avatar.src"></div>
                <div class="user-name">{{ avatar.name }}</div>
              </div>
              <div class="exit" @click="loginOut">退出</div>
            </div>
            <div class="login-button" v-else>
              <div class="login-entrance" @click="openLogin">网页版登录</div>
            </div>
          </div>
        </div>
      </header>

      <!-- 网站头部 -->
      <!--<header>

        <div class="logo-wrap">
          <div class="logo" @click="jumpPlusIndex">
            <img src="../../icons/image/logo-big.png">
          </div>
        </div>

        <div class="nav-list">
          <nav class="nav">
            <div class="nav-item"><a href="https://www.erplus.co/">首页</a></div>
            <div class="nav-item"><a href="https://www.erplus.co/views/plusManager.html">管理团队</a></div>
            <div class="nav-item"><a href="https://www.erplus.co/views/plusCulture.html">加号文化</a></div>
            <router-link to="/" class="nav-item active" tag="div">帮助中心</router-link>
            <div class="nav-item"><a href="https://www.erplus.co/views/recruitment.html">人才与招聘</a></div>
          </nav>
          <div class="login-exit" v-if="isLogin">
            <div class="user">
              <div class="user-icon">
                <img :src="avatar.src">
              </div>
              <div class="user-name" @click="jumpTaskIndex">{{ avatar.name }}</div>
            </div>
            <div class="exit" @click="loginOut">退出</div>
          </div>
          <div class="login-button" v-else>
            <div class="login-entrance" @click="openLogin">网页版登录</div>
          </div>
        </div>

      </header>-->

    </div>
  </div>
</template>

<script>
import {unixCryptTD} from '../../assets/unix-crypt-td'
import sha256Digest from '../../assets/sh256'
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
import axios from 'axios'
import cookieUtil from '../../assets/cookieUtil'
import clickOutside from '../../directives/click-outside/index'
import demonstration from '../demonstration/demonstration'

window.cookieUtil = cookieUtil

export default {
  name: 'headerNav',
  components: {
    demonstration
  },
  data () {
    return {
      showMenuKey: '',
      demShow: false,
      baseUrl: 'https://www.erplus.co',
      imageCode: {
        key: '',
        src: ''
      },
      companyId: 0,
      avatar: {
        src: '',
        name: ''
      },
      isLogin: false,
      dialogFormVisible: false,
      form: {
        name: '',
        region: ''
      },
      formLabelWidth: '250px',
      userPhone: '',
      userPassword: '',
      promptText: '',
      userVeri: '',
      isRegis: false,
      isGraphic: false,
      midNum: '',
      userPhoneVeri: '',
      // 默认验证码等待时间
      waitTime: 60,
      veriText: '获取验证码',
      waitTimeObj: null
    }
  },
  created () {
    if (cookieUtil.get('token')) {
      this.UPDATE_TOKEN(cookieUtil.get('token'))
      this.getUserInfo()
    } else {
      this.isLogin = false
      this.openLogin()
    }
  },
  computed: {
    ...mapState([
      'previewImg'
    ]),
    ...mapGetters([
      'getToken'
    ])
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOKEN'
    ]),
    ...mapActions([
      'action_getWebMobileUrl',
      'action_getImageVerifyCodeBasic',
      'action_checkImageVerifyCode',
      'action_veriCodeLogin',
      'action_login',
      'action_getUserInfo',
      'setUserId'
    ]),
    //测试连接新版官网
    jumpPlusIndex () {
      window.location.href = 'https://www.erplus.co/'
    },
    jumpTask () {
      window.location.href = 'https://www.erplus.co/feature-task'
    },
    jumpProject () {
      window.location.href = 'https://www.erplus.co/feature-project'
    },
    jumpCRM () {
      window.location.href = 'https://www.erplus.co/feature-crm'
    },
    jumpPSI () {
      window.location.href = 'https://www.erplus.co/feature-psi'
    },
    jumpAPE () {
      window.location.href = 'https://www.erplus.co/feature-ape'
    },
    jumpRecruitment () {
      window.location.href = 'https://www.erplus.co/feature-recruitment'
    },
    jumpOA () {
      window.location.href = 'https://www.erplus.co/feature-oa'
    },
    jumpConsultation () {
      window.location.href = 'https://www.erplus.co/support-consultation'
    },
    jumpImplementation () {
      window.location.href = 'https://www.erplus.co/support-implementation'
    },
    jumpPlusTeam () {
      window.location.href = 'https://www.erplus.co/about-team'
    },
    jumpPlusCulture () {
      window.location.href = 'https://www.erplus.co/about-culture'
    },
    jumpJoinPlus () {
      window.location.href = 'https://www.erplus.co/join-plus'
    },
    jumpTaskIndex () {
      // window.location.href = 'https://www.erplus.co/web/pc/#/task'
      this.navigateToDynamicLink(this.companyId)
    },
    showMenu(val) {
      return this.showMenuKey !== val ? this.showMenuKey = val : this.showMenuKey = ''
    },
    goSchedule() {
      this.demShow = !this.demShow
    },
    typeShow(type) {
      switch (type) {
        case 'dem':
          this.demShow = !this.demShow
          break
      }
    },
    codeLogin () {
      if (this.userPhone === '') {
        this.promptText = '请填写手机号码'
        return
      }
      if (this.userPhoneVeri === '') {
        this.promptText = '请输入验证码'
        return
      }
      let params = {
        phone: this.userPhone,
        veri: this.userPhoneVeri,
        midNum: this.midNum
      }
      axios.interceptors.request.use(function (config) {
        // 处理请求之前的配置
        return config
      }, function (error) {
        // 请求失败的处理
        return Promise.reject(error)
      })
      const instance = axios.create({
        baseURL: '',
        timeout: 500,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      function veriCodeLogin (params) {
        return instance.get(`https://www.erplus.co/oauth/v2/token?grant_type=password&username=${params.phone}&password=${params.veri}%23%23%23PMC%23%23%23${params.midNum}&client_id=2_3t7k61w8zz28wc00w0o0swgo0ko48w08c8csk4ss444os4ccgo&client_secret=6o596th97340soswgw8ssswk8gk8cwoo40c4wwccs4g4wswk8`).then(res => res.data)
      }
      veriCodeLogin(params).then(res => {
        if (res.access_token !== undefined && res.access_token !== '') {
          this.LoginSuccess(res)
        } else {
          this.$message({
            type: 'error',
            message: '验证码错误',
            showClose: true
          })
        }
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '验证码错误',
          showClose: true
        })
      })
    },
    openLogin () {
      this.dialogFormVisible = true
    },
    closeLogin () {
      this.dialogFormVisible = false
      this.isRegis = false
    },
    handler_getVeri () {
      if (this.veriText !== '获取验证码') {
        return
      }
      if (this.userPhone === '') {
        this.promptText = '请填写手机号码'
        return
      }
      this.isGraphic = true
      this.action_getImageVerifyCodeBasic().then(res => {
        this.imageCode.key = res.key
        this.imageCode.src = 'data:image/jpg;base64,' + res.imgflow
      })
    },
    sendImgCodeData () {
      if (this.userVeri === '') {
        this.this.promptText = '请输入验证码'
        return
      }
      let params = {
        code: this.userVeri,
        needmsg: 1,
        phoneNumber: this.userPhone,
        key: this.imageCode.key
      }
      this.action_checkImageVerifyCode(params).then(res => {
        if (res.result === 0) {
          this.isGraphic = false
          this.midNum = res.mid
          this.cuntDown()
        } else {
          this.handler_getVeri()
          this.$message({
            type: 'error',
            message: '验证码错误',
            showClose: true
          })
        }
      })
    },
    cuntDown () {
      this.waitTimeObj = setInterval(() => {
        this.waitTime -= 1
        if (this.waitTime > 0) {
          this.veriText = this.waitTime + '秒后重发'
        } else {
          clearInterval(this.waitTimeObj)
          this.waitTime = 60
          this.veriText = '获取验证码'
        }
      }, 1000)
    },
    closeGraphic () {
      this.isGraphic = false
    },
    handler_registered () {
      if (this.waitTime !== 60) {
        return
      }
      this.isRegis = true
    },
    handler_login () {
      if (this.userPhone === '') {
        this.promptText = '请填写手机号码'
        return
      } else if (this.userPassword === '') {
        this.promptText = '请填写密码'
        return
      }
      let pwd = unixCryptTD(this.userPassword, sha256Digest(this.userPassword).substr(0, 2))
      let urlParams = {
        username: this.userPhone,
        password: encodeURIComponent(pwd) + '###PC'
      }
      this.action_login(urlParams).then(res => {
        if (res.access_token !== undefined) {
          this.dialogFormVisible = false
          localStorage.username = urlParams.username
          this.UPDATE_TOKEN(res.access_token)
          this.LoginSuccess(res)
        } else {
          this.promptText = '手机或者密码错误'
        }
      })
      this.promptText = ''
    },
    LoginSuccess (data) {
      let self = this
      axios.interceptors.request.use(function (config) {
        // 处理请求之前的配置
        config.headers.Authorization = 'Bearer ' + self.getToken
        return config
      }, function (error) {
        // 请求失败的处理
        return Promise.reject(error)
      })

      if (process.env.NODE_ENV !== 'production') {
        cookieUtil.unset('token', '/', 'localhost')
        cookieUtil.unset('nickname', '/', 'localhost')
        cookieUtil.set('token', data.access_token, '-1', '/', 'localhost')
        cookieUtil.set('nickname', data.user.nickname, '-1', '/', 'localhost')
        cookieUtil.set('token', data.access_token, '-1', '/', '0.0.0.0')
        cookieUtil.set('nickname', data.user.nickname, '-1', '/', '0.0.0.0')
      } else {
        cookieUtil.unset('token', '/', '.www.erplus.co')
        cookieUtil.unset('token', '/', '.erplus.co')
        cookieUtil.unset('nickname', '/', '.www.erplus.co')
        cookieUtil.unset('nickname', '/', '.erplus.co')
        cookieUtil.set('token', data.access_token, '-1', '/', '.www.erplus.co')
        cookieUtil.set('token', data.access_token, '-1', '/', '.erplus.co')
        cookieUtil.set('nickname', data.user.nickname, '-1', '/', '.erplus.co')
        cookieUtil.set('nickname', data.user.nickname, '-1', '/', '.www.erplus.co')
      }
      this.getUserInfo()

      this.$router.push({name: 'question'})
      this.isLogin = true
      this.dialogFormVisible = false
      this.$message({
        type: 'success',
        message: '登录成功！',
        showClose: false
      })
    },
    navigateToDynamicLink(companyId) {
      this.action_getWebMobileUrl().then(linkUrlRes => {
        try {
          let dynamicData = linkUrlRes.erpData.pc[0];
          let dynamicLink = '';
          let betaCompany = [12, 63, 353, 802, 1829, 1888, 3171, 3176, 4615, 5027, 5028, 6421, 6423, 6444];
          if (betaCompany.indexOf(companyId) > -1) {
            if (dynamicData.grayBetaIds && dynamicData.grayBetaIds.indexOf(companyId) > -1) {
              dynamicLink = dynamicData.grayBetaUrl;
            } else {
              dynamicLink = dynamicData.betaUrl;
            }
          } else if (dynamicData.grayReleaseIds && dynamicData.grayReleaseIds.indexOf(companyId) > -1) {
            dynamicLink = dynamicData.grayReleaseUrl;
          } else {
            dynamicLink = dynamicData.releaseUrl;
          }
          if (window.location.host.indexOf('erplus.co') === -1) {
            dynamicLink = dynamicLink.replace('www.erplus.co', 'www.managerplus.cn')
          }
          window.location.href = dynamicLink;
        } catch (e) {
          this.$message({
            type: 'error',
            message: `${res.erpMsg || '登录异常'}`,
            showClose: true
          })
          // getLastDynamicLink();
        }
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '网络链接错误',
          showClose: true
        })
      })
    },
    getUserInfo () {
      let token = cookieUtil.get('token')
      if (token === null) {
        console.log('token is null')
        return false
      }
      this.action_getUserInfo().then(res => {
        if (res.id !== undefined) {
          this.loadUserInfo(res)
          this.isLogin = true
        } else {
        }
      }).catch(error => {
        this.isLogin = true
        this.$message({
          type: 'error',
          message: `登录失效！请重新登录！`,
          showClose: true
        })
      })
    },
    loadUserInfo (data) {
      this.avatar.src = this.baseUrl + '/uploads/avatars' + data.imageName
      this.avatar.name = data.name
      this.companyId = data.companyId
      this.setUserId(data.id)
    },
    loginOut () {
      cookieUtil.unset('token', '/', 'www.erplus.co')
      cookieUtil.unset('token', '/', '.erplus.co')
      cookieUtil.unset('token', '/', 'https://erplus.co')
      cookieUtil.unset('token', '/', 'localhost')
      this.isLogin = false
      this.$message({
        type: 'warning',
        message: '您已退出登录'
      })
      window.location.href = 'https://www.erplus.co/'
    },
    HiddenClick() {
      this.showMenuKey = ''
    }
  },
  mounted () {
    document.addEventListener('click', this.HiddenClick)
  },
  directives: {
    clickOutside
  },
  watch: {
    userPhone (val) {
      this.promptText = ''
    },
    userPassword (val) {
      this.promptText = ''
    },
    userVeri (val) {
      this.promptText = ''
    },
    userPhoneVeri (val) {
      this.promptText = ''
    }
  }
}
</script>

<style lang="less" scoped>
  .header-wrap {
    width: 100%;
    min-width: 1280px;
    /*border-bottom: 1px solid #eee;*/
  }
  .login-pop-ups {
    width: 100%;
    min-width: 1280px;
    /*max-width: 1356px;*/
    /*margin: 0 auto;*/
  }
  input {
    padding: 0;
    margin: 0;
    outline: none;
  }
  ::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }
  /* 图形验证码 */
  .graphic-veri-wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 199;
  }
  .graphic-veri {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 330px;
    height: 150px;
    padding: 16px 18px 17px 19px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.30);
    border-radius: 1.5px;
    background: #FFFFFF;
  }
  .veri-title {
    height: 22px;
    font-size: 15px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0;
    line-height: 21px;
  }
  .veri-content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 17px;
  }
  .veri-picture {
    width: 114px;
    height: 37px;
  }
  .veri-picture img {
    width: 114px;
    height: 37px;
  }
  .veri-text {
    width: 167px;
    height: 36px;
    border: 1px solid #CCCCCC;
    border-radius: 2.25px;
  }
  .veri-text input {
    box-sizing: border-box;
    width: 167px;
    height: 36px;
    padding: 0 8px 0 9px;
    border: none;
    outline: 0;
    background: #fff;
    font-size: 15px;
    line-height: 36px;
  }
  .cancel-confirm {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 21px;
  }
  .cancel, .confirm {
    width: 51px;
    height: 20px;
    font-size: 10px;
    line-height: 20px;
    text-align: center;
    background: #FFFFFF;
    border: 1px solid #CCCCCC;
    border-radius: 3px;
    cursor: pointer;
  }
  .cancel {
    color: #777;
  }
  .confirm {
    margin-left: 7px;
    color: #fff;
    background: #4A90E2;
  }

  /* 登录弹窗 */
  .dialog-login-wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999;
  }
  .login-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: 480px;
    height: 400px;
    padding: 25px 20px 38px 40px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 1px 1px 50px rgba(0,0,0,.3);
  }

  .dialog-log-title {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
  }
  .title-text {
    font-size: 20px;
    color: rgba(0,0,0,0.87);
  }
  .dialog-log-close {
    width: 18px;
    height: 18px;
    background: url("../../icons/x-mark.svg") no-repeat center center;
    cursor: pointer;
  }

  .options {
    width: 370px;
    margin-left: 12px;
    margin-top: 61px;
  }
  .phone, .password, .examine {
    height: 30px;
  }
  .phone {}
  .password {
    margin-top: 20px;
  }
  .examine {
    margin-top: 13px;
    position: relative;
    cursor: pointer;
  }
  .get-examine {
    position: absolute;
    right: 0;
    top: 3px;
    font-size: 16px;
    color: #4A90E2;
  }
  .phone input, .password input, .examine input {
    width: 370px;
    height: 30px;
    line-height: 30px;
    border: 0;
    border-bottom: 1px solid #ccc;
  }
  .phone input:-webkit-autofill, .phone select:-webkit-autofill {
    background-color: rgb(250, 255, 189) !important;
    background-image: none !important;
    color: rgb(0, 0, 0) !important;
  }
  .password input:-webkit-autofill, .password select:-webkit-autofill {
    background-color: rgb(250, 255, 189) !important;
    background-image: none !important;
    color: rgb(0, 0, 0) !important;
  }
  .more-option {
    display: flex;
    justify-content: space-between;
    margin-top: 36px;
    height: 19px;
    line-height: 19px;
  }
  .remember {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #999;
  }
  .remember label {
    display: flex;
    align-items: center;
  }
  .reme-button {
    width: 13px;
    height: 13px;
    border: 1px solid #979797;
    margin-top: 2px;
    cursor: pointer;
  }
  .reme-text {
    margin-left: 4px;
  }
  .registered {
    width: 112px;
    font-size: 15.79px;
    color: #4A90E2;
    text-align: left;
    cursor: pointer;
  }
  .login-bun {
    width: 242px;
    height: 46px;
    margin: 0 auto;
    margin-top: 12px;
    border-radius: 3px;
    font-size: 18px;
    color: #fff;
    line-height: 46px;
    text-align: center;
    background: #4A90E2;
    cursor: pointer;
  }
  .login-bun-new-user {
    width: 242px;
    height: 46px;
    margin: 0 auto;
    margin-top: 50px;
    border-radius: 3px;
    font-size: 18px;
    color: #fff;
    line-height: 46px;
    text-align: center;
    background: #4A90E2;
    cursor: pointer;
  }
  .prompt {
    width: 100%;
    height: 28px;
    margin-top: 10px;
    color: rgba(215, 36, 32, 0.90);
    text-align: center;
  }

  /* header */
  /*header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    margin: 40px 0 9px;
    min-width: 1310px;
    background: #fff;
  }*/
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 68px;
    min-width: 1280px;
  }

  /*.logo-wrap {
    align-self: flex-start;
  }*/
  .logo {
    display: flex;
    align-items: center;
    height: 38px;
  }
  /*.logo img {
    width: 140px;
    height: 36px;
    margin-left: 200px;
  }
  @media screen and (max-width: 1450px) {
    .logo img {
      margin-left: 150px;
    }
  }
  @media screen and (max-width: 1400px) {
    .logo img {
      margin-left: 90px;
    }
  }*/
  .logo img {
    width: 120px;
    height: 33px;
    margin-left: 290px;
    cursor: pointer;
  }
  @media screen and (max-width: 1650px) {
    .logo img {
      /*margin-left: 130px;*/
      margin-left: 120px;
    }
  }
  @media screen and (max-width: 1400px) {
    .logo img {
      /*margin-left: 130px;*/
      margin-left: 60px;
    }
  }
  .nav-list {
    display: flex;
    position: relative;
    align-self: flex-start;
  }
  /*.nav-list {
    display: flex;
    position: relative;
    align-self: flex-start;
    margin-right: 80px;
  }
  @media screen and (max-width: 1400px) {
    .nav-list {
      margin-right: 50px;
    }
  }*/
  /*.nav {
    display: flex;
    align-items: center;
    height: 38px;
    font-size: 17px;
    color: #333333;
    letter-spacing: 0.8px;
    justify-content: space-between;
  }
  .nav-item {
    margin-right: 72px;
    cursor: pointer;
  }*/
  .nav {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;
    letter-spacing: 0.8px;
    justify-content: space-between;
  }
  .nav-item {
    position: relative;
    z-index: 999;
  }
  /*.active {
    color: #4A90E2;
  }
  .nav-item a{
    color: #333333;
    text-decoration: none;
  }
  .active a{
    color: #4A90E2;
  }
  .nav-item a:hover {
    color: #dddddd;
  }
  .active a:hover {
    color: #4A90E2;
  }*/
  .click-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 68px;
    padding: 0 20px;
    cursor: pointer;
  }
  .click-icon img {
    display: flex;
    align-items: center;
  }
  .click-icon:hover {
    color: #4A90E2;
  }
  .fuc-item {
    position: absolute;
    width: 300px;
    height: 205px;
    top: 50px;
    left: 0;
    display: flex;
    background-color: #ffffff;
    border-radius: 2px;
    color: #333333;
    letter-spacing: 0.8px;
    z-index: 999;
  }
  .fuc-left div {
    display: flex;
    padding: 15px 0;
    margin-left: 20px;
    margin-right: 45px;
    border-top: solid 0.5px #e4e4e4;
    font-size: 15px;
    cursor: pointer;
  }
  .fuc-left div:nth-of-type(1) {
    border-top: solid 0 #e4e4e4;
  }
  .fuc-left div img{
    padding-right: 10px;
  }
  .fuc-left div:hover {
    color: #4A90E2;
  }
  .fuc-right div {
    display: flex;
    padding: 15px 0;
    margin-left: 20px;
    margin-right: 45px;
    border-top: solid 0.5px #e4e4e4;
    font-size: 15px;
    cursor: pointer;
  }
  .fuc-right div:nth-of-type(1) {
    border-top: solid 0 #e4e4e4;
  }
  .fuc-right div img{
    padding-right: 10px;
  }
  .fuc-right div:hover {
    color: #4A90E2;
  }
  .support-item {
    position: absolute;
    width: 150px;
    height: 101px;
    top: 50px;
    left: 20px;
    border-radius: 2px;
    background-color: #ffffff;
    color: #333333;
    z-index: 999;
  }
  .support-item div {
    display: flex;
    justify-content: center;
    color: #333333;
    padding: 15px 0;
    margin: 0 27px;
    border-top: solid 0.5px #e4e4e4;
    font-size: 15px;
    cursor: pointer;
  }
  .support-item div:nth-of-type(1) {
    border-top: solid 0 #e4e4e4;
  }
  .support-item div:hover {
    color: #4A90E2;
  }
  .support-item img {
    padding-right: 10px;
  }
  .plus-item {
    position: absolute;
    width: 150px;
    height: 101px;
    top: 50px;
    left: 20px;
    border-radius: 2px;
    background-color: #ffffff;
    color: #333333;
    z-index: 999;
  }
  .plus-item div {
    display: flex;
    justify-content: center;
    color: #333333;
    padding: 15px 0;
    margin: 0 27px;
    border-top: solid 0.5px #e4e4e4;
    font-size: 15px;
    cursor: pointer;
  }
  .plus-item div:nth-of-type(1) {
    border-top: solid 0 #e4e4e4;
  }
  .plus-item div:hover {
    color: #4A90E2;
  }
  .plus-item img {
    padding-right: 10px;
  }
  .fix-bar {
    width: 200px;
    margin-left: 20px;
    margin-right: 230px;
  }
  @media screen and (max-width: 1650px) {
    .fix-bar {
      margin-right: 60px;
    }
  }
  @media screen and (max-width: 1400px) {
    .fix-bar {
      margin-right: 0;
    }
  }
  /*.login-exit {
    display: flex;
    align-items: center;
  }*/
  .login-exit {
    display: flex;
    align-items: center;
    width: 200px;
  }
  /*.user {
    display: flex;
    align-items: center;
    height: 38px;
    margin-right: 44px;
  }
  .user-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-top: 4px;
    margin-right: 6px;
    transform: translateY(-2px);
  }
  .user-icon img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .user-name {
    height: 38px;
    line-height: 38px;
    font-size: 18px;
    color: #4A90E2;
    cursor: pointer;
  }*/
  .user {
    display: flex;
    align-items: center;
    height: 38px;
    margin-right: 40px;
    cursor: pointer;
  }
  .user-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-top: 4px;
    margin-right: 6px;
    transform: translateY(-2px);
  }
  .user-icon img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .user-name {
    height: 38px;
    line-height: 38px;
    font-size: 15px;
    color: #4A90E2;
  }
  /*.exit {
    height: 38px;
    line-height: 38px;
    font-size: 18px;
    color: #777;
    cursor: pointer;
  }
  .login-exit {
    display: flex;
    width: 250px;
  }
  .login-button {
    box-sizing: border-box;
    width: 250px;
    padding-left: 38px;
  }
  .login-entrance {
    box-sizing: border-box;
    width: 122px;
    height: 38px;
    margin-right: 90px;
    color: #4a90e2;
    padding: 7px 20px;
    border: 1px solid #4a90e2;
    border-radius: 4px;
    font-size: 15px;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
  }
  .login-entrance:hover{
    box-shadow: 0 0 5px rgb(18, 101, 211);
  }*/
  .exit {
    height: 38px;
    line-height: 38px;
    font-size: 15px;
    color: #777;
    cursor: pointer;
  }
  .login-button {
    width: 122px;
    height: 38px;
  }
  .login-entrance {
    height: 20px;
    line-height: 20px;
    border: 1px solid #4a90e2;
    border-radius: 4px;
    color: #4a90e2;
    padding: 7px 20px;
    font-size: 15px;
    text-align: center;
    cursor: pointer;
  }
  .login-entrance:hover{
    box-shadow: 0 0 5px rgb(18, 101, 211);
  }
</style>



// WEBPACK FOOTER //
// src/components/header-nav/header-nav.vue